<template>
    <div
        class="animate-[fadeIn_1s_ease-in-out] flex flex-col items-center justify-center flex-grow absolute left-8 right-8 top-8 bottom-8"
    >
        <p class="text-fau-blue-bright text-4xl">Thank you!</p>
    </div>
</template>
